<template>
  <div class="home">
    <div
      :style="`background-color:${color.rgb().css()};`"
      :class="{'color-bright':getLight(color) === 'b'}"
      class="display">
      <div class="main-display">
        <CopyButton
          :fill-color="getLight(color)"
          :copied="isCopied"
          class="copy"
          @click.native="copy(color.rgb().css())" />
        <!--
        <ShareButton
          :fill-color="getLight(color)"
          class="share"
          @click.native="share(colorSelected.name)" />
        -->
        <PalettesPicker
          :border-color="getLight(color)"
          :palettes-list="getPalettesList()"
          :palette="palette"
          :key="palettesKey"
          class="palettes"
          @paletteChange="changePalette" />
        <RandomButton
          :fill-color="getLight(color)"
          class="random"
          @click.native="random" />
        <ColorSeriesPicker
          :border-color="getLight(color)"
          :key="seriesKey"
          :series-filters="seriesFilters"
          class="series"
          @seriesChange="changeColorSeries" />
        <div class="kanji">
          {{ colorSelected.palette||'' }}
        </div>
        <div class="romaji">
          {{ colorSelected.color||palette + ' colors' }}
        </div>
        <div class="rgb-block">
          <div
            v-for="(el,i) in ['r','g','b']"
            :key="el"
            :style="`width:${color.rgb()?(color.rgb().toJSON()[i + 1] * 100):0}%`"
            :class="{[el]:true,'bg-bright':getLight(color) === 'b'}" />
        </div>
        <div
          v-if="color.rgb().toJSON()"
          class="rgb-number">
          <template v-for="el in ['R','G','B']">
            <div :key="el">{{ el }}</div>
            <div
              :key="el + 'n'"
              class="n">0</div>
          </template>
        </div>
        <div
          v-if="color.cmyk().toJSON()"
          class="cmyk-number">
          <div
            v-for="el in ['c','m','y','k']"
            :key="el"
            :class="{[el]:true}"
            class="n">0</div>
        </div>
      </div>
      <ColorOps
        :color="color" />
    </div>
    <div class="tab-wrapper">
      <div class="tab">
        <ColorTab
          v-for="color in colorList"
          :id="'color' + color.number"
          :key="color.number"
          :head="color.number?color.number.toString():color.name"
          :title="color.color"
          :rgb="color.rgb"
          :r="getR(color.rgb)"
          :g="getG(color.rgb)"
          :b="getB(color.rgb)"
          :active="color.active"
          class="js-tab-item tab-item"
          @click.native="changeColor(color)" />
      </div>
    </div>
  </div>
</template>

<script>

import anime from 'animejs'
import color from 'onecolor'

import ColorTab from '@/components/ColorTab.vue'
import ColorSeriesPicker from '@/components/ColorSeriesPicker.vue'
// import ShareButton from '@/components/ShareButton.vue'
import CopyButton from '@/components/CopyButton.vue'
import RandomButton from '@/components/RandomButton.vue'
import PalettesPicker from '@/components/PalettesPicker.vue'
import ColorOps from '@/components/ColorOps.vue'

// NOw it´s planned to be dynamic
// import colorList from '@/data/werner'

import {
  checkInSight,
  checkInSightInit,
  throttle,
  clipboardCopy,
} from '@/util.js'

let colorList = {}

let palettesList = {}

export default {
  name: 'Home',
  components: {
    ColorTab,
    ColorSeriesPicker,
    CopyButton,
    RandomButton,
    PalettesPicker,
    ColorOps,
  },
  data () {
    return {
      palette: {},
      palettesList: [],
      palettesKey: 0,
      seriesKey: 9999,
      seriesFilters: 'all',
      colorList: [],
      colorSelected: {},
      isCopied: false,
      lastEls: null,
      active: 'no-active',
    }
  },
  computed: {
    color () {
      return color('#' + this.colorSelected.rgb)
    },
  },
  watch: {
    colorList () {
      this.$nextTick(() => {
        checkInSightInit(this.listAnime)()
      })
    },
    colorSelected () {
      // this.color = color('#' + this.colorSelected.rgb)
      this.$nextTick(() => {
        this.displayAnime()
      })
    },
    $route (r) {
      this.retrievePaletteAndSelect(r.query.p, r.query.c, r.query.f)
    },
  },
  created () {
    palettesList = this.loadJSONfile('palettes')
    this.palettesList = palettesList
    this.palettesList.forEach(function (el, i) {
      el['active'] = false
    })
    this.retrievePaletteAndSelect(this.$route.query.p, this.$route.query.c, this.$route.query.f)
  },
  mounted () {
    this.$emit('init', this.init())
  },
  methods: {
    async init () {
      // Vanila scroll listening
      document
        .querySelector('.tab-wrapper')
        .addEventListener('scroll', throttle(checkInSight(this.listAnime)))
      // Window Timeout
      window.addEventListener(
        'resize',
        throttle(checkInSight(this.listAnime), 1000)
      )
    },
    setMetaTitle () {
      document.title = this.colorSelected.color + ' | ' + this.colorSelected.palette + ' - ' + 'World Colors'
      let colSel = this.colorSelected
      let col = this.color
      // Iterate Nodelist
      let meta = document.getElementsByTagName('meta')
      Array.prototype.forEach.call(meta, function (el, i) {
        if (el.name.toLowerCase() === 'description') {
          el.content = 'HEX: #' + colSel.rgb + ' | ' + 'RGB: #' + col.rgb().css()
        }
      })
    },
    forceRerender () {
      this.palettesKey += 1
      this.seriesKey += 1
    },
    getPalettesList () {
      return this.palettesList
    },
    getR (rgb) {
      return color('#' + rgb).rgb().red() * 255
    },
    getG (rgb) {
      return color('#' + rgb).rgb().green() * 255
    },
    getB (rgb) {
      return color('#' + rgb).rgb().blue() * 255
    },
    logMe (name, event) {
      console.log(name, event)
    },
    logColor (event) {
      // console.log('toJSON', event.cmyk().toJSON())
      // console.log('css', event.css())
      console.log('RGB', event.rgb().toJSON())
      // console.log('HSL', event.hsl())
      // console.log('CMYK', event.cmyk())
    },
    loadJSONfile (f) {
      let currentJsonFile = require('../data/' + f + '.json')
      return currentJsonFile
    },
    getLight (color) {
      let light = color.lightness()
      if (light > 0.4) return ''
      else return 'b'
    },
    scrollToEl (sel) {
      let el = document.getElementById(sel)
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
        })
      }
    },
    retrievePaletteAndSelect (palette, rgb, filter) {
      let search

      if (this.$route.query.p) {
        search = this.$route.query.p
      }

      if (palette) {
        search = palette
      } else if (palette === null || palette === undefined) {
        search = this.palettesList[0].name
      }

      this.palettesList.forEach(function (el, i) {
        el['active'] = false
      })

      if (search === undefined) {
        // this.palette = this.palettesList[0].name
        this.palette = this.palettesList[0]
      } else {
        // Encontrar un valor en un Array de Objetos
        let findPalette = this.palettesList.find(
          (element, index) =>
            element.name === search
        )
        findPalette.active = true

        // this.palette = findPalette.name
        this.palette = findPalette
      }

      colorList = this.loadJSONfile(this.palette.name)

      this.colorList = colorList

      this.retrieveColorAndSelect(rgb, filter)
      this.setMetaTitle(rgb)
    },
    retrieveColorAndSelect (rgb, filter) {
      let findColor
      if (rgb) {
        // la query con nombre c, se corresponde con el campo rgb del objeto del array
        this.colorList.forEach(function (el, i) {
          el['active'] = false
        })
        // Encontrar un valor en un Array de Objetos
        findColor = this.colorList.find(
          (element, index) =>
            element.rgb === rgb
        )
        // Activar ese color
        findColor.active = true
        // Asignar el color encontrado al seleccionado.
        // this.logMe(findColor)
      } else {
        // sino, se carga el default color.
        findColor = this.colorList[0]
        findColor.active = true
      }
      this.colorSelected = findColor
      this.changeColorSeries(filter, false)
      // this.logColor(this.color)
      // if (this.seriesFilter !== 'all') this.changeColorSeries(this.seriesFilter)
    },
    changeColorSeries (selSeriesFilter, gotoFirst = true) {
      let ST = document.querySelector('.tab-wrapper')
      if (ST) ST.scrollTop = 0
      if (selSeriesFilter === 'all' || selSeriesFilter === undefined) {
        // Se muestra todo el array:
        // this.colorlist se iguala al import colorList
        this.colorList = colorList
        this.seriesFilters = 'all'
      } else {
        // Como filtrar elementos de un array
        // el campo c es la colorSeries, por tanto el valor a filtrar según el input
        this.colorList = colorList.filter(
          val =>
            val.c === selSeriesFilter
        )
        this.seriesFilters = selSeriesFilter
      }
      // this.changeColor(this.colorList[0].rgb)
      if (gotoFirst) {
        this.colorList.forEach(function (el, i) {
          el['active'] = false
        })
        this.colorList[0].active = true
        this.colorSelected = this.colorList[0]
      }
      this.changeColor(this.colorSelected)
    },
    changeColor (color) {
      // watch $route and change color
      // Sends a push to router
      this.$router.push({
        path: '/',
        query: {
          c: color.rgb,
          p: this.palette.name,
          f: this.seriesFilters,
        },
      })
      let el = document.getElementById('color' + color.number)
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
        })
      }
    },
    changePalette (p) {
      // watch $route and change palette
      // Sends a push to router
      this.forceRerender()
      this.$router.push({
        path: '/',
        query: {
          p: p,
          // f: this.seriesFilters,
        },
      })
    },
    share (name) {
      let location = window.location.href
      window.open(
        `https://twitter.com/intent/tweet?hashtags=nipponcolors&via=zhoudejie&text=${name ||
          ''}&url=${location}`
      )
    },
    copy (colortext) {
      if (!this.isCopied) {
        // clipboardCopy(`${colortext}`)
        clipboardCopy(colortext)
        this.isCopied = true
        setTimeout(() => {
          this.isCopied = false
        }, 1000)
      }
    },
    random () {
      let random = colorList[Math.floor(Math.random() * colorList.length)]
      this.changeColor(random)
    },
    listAnime (el, isInit) {
      if (this.lastEls && isInit) {
        anime.remove(this.lastEls)
      }
      this.lastEls = el
      anime({
        targets: el,
        translateY: [250, 0],
        opacity: [0, 1],
        easing: 'easeOutSine',
        delay: function (el, i, l) {
          return i * 22
        },
      })
    },
    displayAnime () {
      let monji = document.querySelectorAll('.display .kanji,.romaji')
      let rgb = document.querySelectorAll('.display .rgb-number .n')
      let cmyk = document.querySelectorAll('.display .cmyk-number .n')

      let scrollToEl = this.scrollToEl
      let num = this.colorSelected.number
      anime.remove([monji, rgb, cmyk])
      anime({
        targets: monji,
        translateX: [150, 0],
        opacity: [0, 1],
        easing: 'easeOutSine',
        complete: function () {
          scrollToEl('color' + num)
        },
      })
      anime({
        targets: rgb,
        innerHTML: (el, i, l) => {
          // return this.colorSelected.Drgb[i]
          return this.color.rgb().toJSON()[i + 1] * 255
        },
        round: 1,
        easing: 'easeOutSine',
        duration: 33,
      })
      anime({
        targets: cmyk,
        innerHTML: (el, i, l) => {
          // return this.colorSelected.cmyk.slice(i * 3, (i + 1) * 3)
          return this.color.cmyk().toJSON()[i + 1] * 100 + ''
        },
        round: 1,
        easing: 'easeOutSine',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/mixin.scss';

$spc: 14vh;

.home {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .display {
    position: relative;
    height: 100%;
    width: 100px;
    flex-grow: 1;
    transition: all 1s;
    .main-display {
      height: calc(100% - #{$spc});
      position: relative;
    }
    .palettes,
    .series,
    .share,
    .copy,
    .random {
      position: absolute;
      height: 2rem;
      width: 2rem;
      top: 1rem;
      //bottom: 1.5rem;
    }
    .share,
    .copy,
    .random {
      box-sizing: border-box;
      transition: all 1s;
      fill: #0c0c0c;
    }
    .palettes {
      left: 1rem;
    }
    .series {
      left: 2.5 * 1rem + 1;
    }
    .share {
      left: 2.5 * 1rem + 1;
    }
    .copy {
      left: 2.5 * 3rem + 1;
      padding: .36rem;
    }
    .random {
      left: 2.5 * 2rem + 1;
      padding: .36rem;
    }
    .romaji {
      position: absolute;
      bottom: 4rem;
      left: .5rem;
      //writing-mode: vertical-lr;
      text-transform: capitalize;
      letter-spacing: 0.2rem;
    }
    .kanji {
      position: absolute;
      bottom: 6rem;
      left: .5rem;
      //writing-mode: vertical-lr;
      letter-spacing: 0.2rem;
      font-size: 1.4rem;
    }
    .rgb-block {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 2px;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      .r,
      .g,
      .b {
        transition: all 1s;
        background-color: #0c0c0c;
        height: 3px;
        border-radius: .1rem;
        width: 0%;
        margin-top: 2px;
      }
    }
    .rgb-number {
      //font-family: 'MONO';
      font-size: 1.3rem;
      display: flex;
      justify-content: space-around;
      position: absolute;
      bottom: 1rem;
      left: 0;
      right: 0;
      .n {
        font-size: 72%;
        line-height: 1.3rem;
        align-self: flex-end;
      }
    }
    // mononspace needed
    .cmyk-number {
      //font-family: 'MONO';
      font-size: 1.3rem;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      //margin: 2rem 1rem;
      position: absolute;
      bottom: 4rem;
      left: 0;
      right: .5rem;
      .n {
        &::after {
          margin-bottom: 0.5rem;
          margin-left: -0.5rem;
          display: inline-block;
          font-size: 1rem;
          position: relative;
          top: -0.8rem;
        }
      }
      .c {
        &::after {
          content: 'c';
        }
      }
      .m {
        &::after {
          content: 'm';
        }
      }
      .y {
        &::after {
          content: 'y';
        }
      }
      .k {
        &::after {
          content: 'k';
        }
      }
    }
  }
  .tab-wrapper {
    flex-shrink: 0;
    height: 100%;
    overflow-y: scroll;
    flex-basis: 38%;
    @include for-phone {
      flex-basis: 38%;
    }
    @include for-tablet-up {
      flex-basis: 50%;
    }
    @include for-desktop {
      flex-basis: 50%;
    }
    @include for-desktop-plus {
      flex-basis: 50%;
    }
    .tab {
      min-height: 100%;
      width: 100%;
      position: relative;
      &:before {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        background: url(../assets/64253519_p9.png);
        background-attachment: local;
        background-repeat: repeat;
        opacity: 0.3;
      }
      @include for-tablet-up {
        display: flex;
        justify-content: flex-start;
        align-content: flex-start;
        flex-wrap: wrap;
      }
      .tab-item {
        margin-bottom: 1rem;
        @include for-phone {
          width: 100%;
        }
        @include for-tablet-up {
          width: 33.333333%;
          &.active {
            width: 100%;
          }
        }
        @include for-desktop {
          width: 25%;
          &.active {
            width: 100%;
          }
        }
        @include for-desktop-plus {
          width: 20%;
          &.active {
            width: 100%;
          }
        }
      }
    }
  }
}
.color-bright {
  color: #fffffb !important;
}
.bg-bright {
  background-color: #fffffb !important;
}
.js-tab-item {
  // for animate initial state
  opacity: 0;
}
</style>
